import {TableCell as MUITableCell} from '@mui/material'
import React from 'react'

interface TableCellProps extends React.ComponentProps<typeof MUITableCell> {}

export const TableCell: React.FC<TableCellProps> = (props) => {
  return <MUITableCell {...props} />
}
